import styled from "styled-components";
import { SolutionColors } from "@smartsuite/types/lib/constants/color";
import { GrayColors } from "@smartsuite/types";

export const Container = styled.div`
  .modal {
    padding-top: 16px;

    border-radius: 4px;
    background-color: ${GrayColors["G-0"]};
  }
`;

export const InputList = styled.div`
  background-color: ${GrayColors["G-0-5"]};
  border: 1px solid ${GrayColors["G-1-5"]};
  border-radius: 8px;
  padding: 10px 15px 10px 15px;

  .thin-border {
    border: none;
    input,
    .single-select,
    .react-input-group {
      order: none;
    }
  }
`;

export const Desciription = styled.div`
  padding: 0px 0 10px 0;
  font-size: 13px;
  line-height: 18px;
  font-weight: 400;
`;

export const Close = styled.div`
  position: absolute;
  top: -5px;
  right: 15px;
  display: flex;

  color: ${GrayColors["G-5"]};
  background-color: #f3f3f4;
  border-radius: 20%;
  align-items: center;
  justify-content: center;
  padding: 6px 6px 6px 6px;

  cursor: pointer;

  &:hover {
    color: ${GrayColors["G-7"]};
  }
`;

export const DescriptionList = styled.div`
  margin: auto;
  margin-bottom: 3px;

  .error {
    input,
    .single-select,
    .react-input-group {
      border: 1px solid ${SolutionColors.basePrimaryRed} !important;
      border-radius: 5px;
    }
  }
`;

export const ErrorMessage = styled.div`
  color: ${SolutionColors.basePrimaryRed};
  position: relative;
  top: -10px;
  font-size: 13px;
`;

export const ModalContent = styled.div`
  padding: 20px 30px 10px 30px;
  // background-color: ${GrayColors["G-0-5"]};
`;

export const FooterError = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 0;
`;

export const FooterErrorText = styled.div`
  color: ${SolutionColors.basePrimaryRed};
  margin-left: 8px;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
`;
